var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4472_32180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83398 18.002C8.83416 12.9396 12.9376 8.83611 18 8.83594C18.4602 8.83594 18.834 9.20871 18.834 9.66895C18.834 10.1292 18.4602 10.502 18 10.502C13.8581 10.5021 10.5002 13.8601 10.5 18.002C10.5 22.144 13.858 25.5018 18 25.502C22.1421 25.502 25.5 22.1441 25.5 18.002C25.5002 17.5419 25.8739 17.1689 26.334 17.1689C26.794 17.1691 27.1668 17.542 27.167 18.002C27.167 23.0646 23.0626 27.1689 18 27.1689C12.9375 27.1688 8.83398 23.0645 8.83398 18.002ZM13 18.002C13.0002 15.2408 15.2388 13.0021 18 13.002C18.4602 13.002 18.834 13.3757 18.834 13.8359C18.8338 14.296 18.4601 14.6689 18 14.6689C16.1593 14.6691 14.6672 16.1613 14.667 18.002C14.667 19.8428 16.1592 21.3358 18 21.3359C19.8409 21.3359 21.334 19.8429 21.334 18.002C21.3342 17.5419 21.7069 17.1689 22.167 17.1689C22.6271 17.1689 22.9998 17.5419 23 18.002C23 20.7634 20.7614 23.002 18 23.002C15.2387 23.0018 13 20.7633 13 18.002ZM23.9668 8.84668C24.2311 8.88957 24.4593 9.05644 24.5791 9.2959L25.2871 10.7129L26.7061 11.4238C26.9456 11.5436 27.1133 11.7709 27.1562 12.0352C27.1991 12.2995 27.1121 12.5684 26.9229 12.7578L24.4229 15.2578C24.2667 15.414 24.0549 15.5019 23.834 15.502H21.6787L18.5898 18.5918C18.2645 18.9172 17.7366 18.917 17.4111 18.5918C17.0857 18.2664 17.0857 17.7385 17.4111 17.4131L20.5 14.3242V12.1689L20.5039 12.0869C20.5228 11.8961 20.6075 11.7169 20.7441 11.5801L23.2441 9.08008L23.3193 9.01367C23.5012 8.87089 23.7356 8.80923 23.9668 8.84668ZM22.167 12.5137V13.8359H23.4883L24.9268 12.3965L24.2939 12.0811C24.1731 12.0206 24.0695 11.9318 23.9912 11.8232L23.9219 11.708L23.6045 11.0752L22.167 12.5137Z",
    fill: "#3F3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4472_32180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.8268087e8b1d6ce529bccc08211a7f45.svg";
export { ForwardRef as ReactComponent };